import {request} from '@/helpers/apiClient'
import {PRODUCTS_CONFIG} from '@/utils/constants/apiConfig/productsConfig'


export const getProductList = (body, queryParams) => request(PRODUCTS_CONFIG.PRODUCT_LIST(queryParams), { data: body })
export const getProductCsvFile = (body, queryParams) => request(PRODUCTS_CONFIG.PRODUCT_CSV_DOWNLOAD(queryParams), { data: body })
export const updateProduct = (productData) => request(PRODUCTS_CONFIG.UPDATE_PRODUCT, { data: productData })
export const uploadProductMedia = (productId, mediaData) => request(PRODUCTS_CONFIG.UPLOAD_PRODUCT_MEDIA(productId), { formData: mediaData })